import { Button, Label, Typography } from "@/components/ui";
import { cn } from "@/lib/utils/cn";

import { Plus } from "lucide-react";
import pluralize from "pluralize";

export interface ContactSubItemSectionProps {
  label: string;
  icon: React.ReactNode;
  itemCount?: number;
  children?: React.ReactNode;
  handleAdd?: () => void;
  hasCreatePermission?: boolean;
  hideAddButton?: boolean;
  className?: string;
}

export const ContactSubItemSection = ({
  label,
  children,
  className,
  icon,
  itemCount = 2,
  handleAdd,
  hasCreatePermission,
  hideAddButton,
}: ContactSubItemSectionProps) => {
  return (
    <>
      <div className="mb-2 flex items-center justify-between">
        <div className="flex items-center space-x-2">
          {icon}
          <Label className="text-lg font-semibold">
            {pluralize(label, itemCount)}
          </Label>
        </div>
        {hasCreatePermission && !hideAddButton && (
          <Button
            variant="outline"
            size="sm"
            onClick={handleAdd}
            data-testid="add-contact-sub-item"
          >
            <Plus className="mr-2 h-4 w-4" />{" "}
            <Typography className="hidden md:block">Create {label}</Typography>
          </Button>
        )}
      </div>
      <div className={cn("grid grid-cols-1 gap-4 lg:grid-cols-2", className)}>
        {children}
      </div>
    </>
  );
};
